import * as HLF from "html-living-framework";
import { PowerupData } from "../Data/PowerupData";
import * as VoiceOver from "../Data/VoiceOverKeys";

export enum PowerupType {
    SPEED,
    HEALTH,
    INVULN,
    SHRINK,
    NUM_ELEMENTS,
}

export class Powerups {
    private static _data: ReadonlyArray<PowerupData>;

    public static get data(): ReadonlyArray<PowerupData> {
        if (this._data === undefined) {
            this._data = Powerups.initData();
        }
        return this._data;
    }

    private static initData(): ReadonlyArray<PowerupData> {
        const data: PowerupData[] = new Array<PowerupData>(PowerupType.NUM_ELEMENTS);

        data[PowerupType.SPEED] = new PowerupData(
            "powerup-icon-rocket",
            HLF.Colour.rgbToHex(255, 155, 57),
            [ VoiceOver.POWERUP_SPEED_01 ],
        );

        data[PowerupType.HEALTH] = new PowerupData(
            "powerup-icon-heart",
            HLF.Colour.rgbToHex(255, 105, 65),
            [ VoiceOver.POWERUP_HEALTH ],
        );

        data[PowerupType.INVULN] = new PowerupData(
            "powerup-icon-shield",
            HLF.Colour.rgbToHex(68, 112, 255),
            [ VoiceOver.POWERUP_SHIELD ],
        );

        data[PowerupType.SHRINK] = new PowerupData(
            "powerup-icon-shrink",
            HLF.Colour.rgbToHex(186, 243, 122),
            [ VoiceOver.POWERUP_SHRINK ],
        );

        return data;
    }
}
